import Vue from 'vue'
import axios from 'axios'
import { MessageBox, Message, Loading } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import i18n from '@/lang/index'
import Qs from 'qs'
import router from '@/router'

// create an axios instance
const timeout = 900000
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout, // request timeout
  loading: true, // 是否启用全局的loading
  responseError: true // 是否启用全局的错误信息拦截
})

let loadingInstance
let isShowSessionOut = false
let requestCount = 0

// request interceptor
service.interceptors.request.use(
  config => {
    if (config.loading) {
      startLoading()
    }
    if (!config.headers.sessionId && store.getters.token) {
      if (getToken() !== 'null' && getToken() !== null) {
        config.headers['sessionId'] = getToken()
      }
    }
    // config.headers['requestType'] = 'ajax'
    let language = ''
    if (store.getters.language === 'zh') {
      language = 'zh_CN'
    } else if (store.getters.language === 'en') {
      language = 'en_US'
    } else if (store.getters.language === 'spanish') {
      language = 'spanish'
    }
    config.headers['language'] = language

    config.paramsSerializer = (params) => {
      return Qs.stringify(params, { indices: false })
    }

    return config
  },
  error => {
    // do something with request error
    hideLoading()
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    if (response.config.loading) {
      hideLoading()
    }
    return new Promise((resolve, reject) => {
      if (response.data.code === '0014') {
        if (isShowSessionOut) return Promise.reject(i18n.t('common.sessionTimeout'))
        isShowSessionOut = true
        MessageBox.alert(i18n.t('common.sessionTimeout'), {
          confirmButtonText: i18n.t('common.login'),
          callback: () => {
            isShowSessionOut = false
            store.dispatch('user/resetToken').then(() => {
              router.push('/login')
              // window.location.reload()
              // window.location.href = process.env.VUE_APP_ETOWER_URL
            })
          }
        })
        return Promise.reject(i18n.t('common.sessionTimeout'))
      } else if (response.data.code === '0017') {
        MessageBox.alert(response.data.message, {
          confirmButtonText: i18n.t('navbar.loginIn'),
          callback: () => {
            store.dispatch('user/resetToken').then(() => {
              router.push('/login')
              // window.location.reload()
              // window.location.href = process.env.VUE_APP_ETOWER_URL
            })
          }
        })
      } else if (response.config.responseError && response.data.code !== '0') {
        if (response.data.errors && response.data.errors.length > 0) {
          Vue.prototype.$openErrorMessage(response.data.errors)
          reject(response.data)
        } else {
          Message({
            message: response.data.message,
            type: 'error',
            duration: 3 * 1000
          })
          reject(response.data)
        }
        return
      }
      resolve(response.data)
    })
  },
  error => {
    hideLoading()
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

function startLoading() {
  if (requestCount === 0) {
    if (loadingInstance) loadingInstance.close()
    const dialogList = document.getElementsByClassName('el-dialog')
    let target = '.app-main'
    if (dialogList && dialogList.length > 0) {
      Array.prototype.forEach.call(dialogList, el => {
        if (el.className.includes('loading-dialog')) el.className = el.className.replace(/ loading-dialog/g, '')
        if (el.parentNode.style.display !== 'none') el.className += ' loading-dialog'
      })
      target = Array.prototype.some.call(dialogList, el => el.parentNode.style.display !== 'none') ? '.loading-dailog' : '.app-main'
    }
    loadingInstance = Loading.service({
      text: '',
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, .6)',
      target,
      body: false
    })
    // 超时自动关闭loading
    setTimeout(() => {
      if (loadingInstance) loadingInstance.close()
    }, timeout)
  }
  requestCount++
}

export function hideLoading() {
  if (requestCount <= 0) return
  requestCount--
  if (requestCount === 0) {
    // 延迟300ms关闭，防止时间过短，出现闪屏的现象
    setTimeout(() => {
      if (loadingInstance) loadingInstance.close()
    }, 300)
  }
}

export default service
